module.exports = __webpack_public_path__ + "static/media/cough0.0e480301.png";